import DesListLibraryContentViewModel from 'viewmodel/DesListLibraryContentViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesListLibraryContent extends DesBaseCatalogAcc {
    constructor() {
        super(DesListLibraryContentViewModel);
    }

    get libraryId() {
        return this.getAttribute('libraryid') || this.getAttribute('library-id');
    }

    get containerId() {
        return this.getAttribute('containerid') || this.getAttribute('container-id');
    }

    get folderId() {
        return this.getAttribute('folderid') || this.getAttribute('folder-id');
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    getProps() {
        return {
            libraryid: this.libraryId,
            containerid: this.containerId,
            folderid: this.folderId
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale', 'libraryid', 'library-id',
            'containerid', 'container-id'];
    }
}

if (!window.customElements.get('des-list-library-content')) {
    window.customElements.define('des-list-library-content', DesListLibraryContent);
}
